var map = {
	"./bouble_1.png": 28,
	"./bouble_1_d.png": 29,
	"./bouble_2.png": 30,
	"./bouble_2_d.png": 31,
	"./bouble_3.png": 32,
	"./bouble_3_d.png": 33,
	"./bouble_4.png": 34,
	"./bouble_4_d.png": 35,
	"./cover.png": 36,
	"./cover_desktop.png": 37,
	"./dossier_arrow.png": 38,
	"./dossier_character_1.png": 39,
	"./dossier_character_2.png": 40,
	"./dossier_character_3.png": 41,
	"./dossier_character_4.png": 42,
	"./dossier_character_5.png": 43,
	"./dossier_corner.png": 44,
	"./dossier_pin.png": 45,
	"./fb.png": 46,
	"./gameover_pic.png": 47,
	"./gameover_pic_d.png": 48,
	"./instructions_1.png": 49,
	"./instructions_2.png": 50,
	"./instructions_4.png": 51,
	"./instructions_5.png": 52,
	"./instructions_6.png": 53,
	"./intro_icon_bottom.png": 54,
	"./intro_icon_left.png": 55,
	"./intro_icon_right.png": 56,
	"./score.png": 57,
	"./stamp.png": 58,
	"./summary.png": 59,
	"./summary_d.png": 60,
	"./tg.png": 61,
	"./time.png": 62,
	"./tw.png": 63,
	"./vk.png": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;